import React, {useState} from 'react';
import {Button, Card} from "antd";
import useAPI from "hooks/API";

interface Update {
  state: "idle" | "inprogress" | "success" | "failure",
  message?: string
}


export const SourceParityRateUpdates = () => {
  const [tefasUpdate, setTefasUpdate] = useState<Update>({state: "idle"});
  const [externalUpdate, setExternalUpdate] = useState<Update>({state: "idle"});
  const api = useAPI();

  const handleUpdate = (resource: string, statusSetter: (u: Update) => void) => {
    statusSetter({state: "inprogress"});
    api.post(`/admin/resources/update/${resource}`)
      .then(res => {
        const numRes = parseInt(res);
        if (numRes > 0) statusSetter({state: "success", message: `${res} values updated`});
        else statusSetter({state: "success", message: `No updates`});
      })
      .catch(() => {
        statusSetter({state: "failure", message: "Failed to update"});
      })
  }

  const UpdateCard = ({title, update, handler}: {title: string, update: Update, handler: () => void}) => {
    return <Card bordered title={title} style={{width: "40vw"}}>
      {
        update.message ? <div style={{marginBottom: "1em"}}>{update.message}</div> : null
      }
      <Button onClick={handler} loading={update.state === "inprogress"}>Update</Button>
    </Card>
  }

  return (
    <div>
      <h2>Parity Updates</h2>
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <UpdateCard title={"TEFAS"} update={tefasUpdate} handler={() => handleUpdate('tefas', setTefasUpdate)} />
        <UpdateCard title={"BP"} update={externalUpdate} handler={() => handleUpdate('external', setExternalUpdate)} />
      </div>
    </div>
  );
}

export default SourceParityRateUpdates;
